<template>
  <b-row
    class="d-flex flex-row align-items-start justify-content-start"
    no-gutters
  >
    <b-row
      class="d-flex flex-row align-items-start justify-content-start px-3 py-1 w-100 table-container-row"
      no-gutters
    >
      <b-table
        ref="selectableTable"
        :bordered="false"
        :borderless="true"
        :hover="true"
        show-empty
        select-mode="multi"
        class="table-element"
        thead-class="table-header font-secondary"
        tbody-class="table-body"
        :busy="isLoading"
        :fields="transactionsHeader"
        :items="transactionsItems"
      >
        <!-- table busy state -->
        <template #table-busy>
          <div class="text-center text-muted my-3">
            <b-spinner class="align-middle"></b-spinner>
            <span class="text-left mx-1">Loading...</span>
          </div>
        </template>
        <!-- table empty state -->
        <template #empty="scope">
          <b-row
            class="d-flex flex-row align-items-center justfiy-content-center py-5"
            no-gutters
          >
            <h6 class="text-center mb-0 mx-auto my-5">
              {{ scope.emptyText }}
            </h6>
          </b-row>
        </template>
        <!-- transaction Date  -->
        <template #cell(transactionDate)="data">
          <b-col
            class="d-flex flex-column align-items-start justify-content-center px-0"
          >
            <span class="main-text">{{ data.value }}</span>
          </b-col>
        </template>
        <!-- transaction Description -->
        <template #cell(transactionDescription)="data">
          <span class="main-text mb-2">{{ data.value }}</span>
        </template>
        <!-- transaction Amount  -->
        <template #cell(transactionAmount)="data">
          <span class="main-text mb-2">{{ `${currency} ${data.value}` }}</span>
        </template>
      </b-table>
    </b-row>
    <b-row
      class="d-flex flex-row align-items-center justify-content-center my-4 px-3 w-100"
      no-gutters
    >
      <b-col
        class="d-flex flex-column align-items-center justify-content-start"
      >
        <!-- error message span class -->
        <span
          v-if="uploadError.status"
          class="block text-center text-sm text-danger font-body mt-1 mb-3"
        >
          {{ uploadError.message }}
        </span>
        <b-button
          variant="main-green"
          class="d-flex flex-row align-items-center justify-content-center mr-2 my-3 my-lg-0 px-4 py-2 border-0 rounded-lg add-question-btn"
          pill
          @click="uploadStatement()"
          :disabled="getAll.date_col === null"
        >
          <span class="d-inline mx-1 py-1">Upload my statement</span>
        </b-button>
      </b-col>
    </b-row>
  </b-row>
</template>
<script>
// services
import { UploadMatchBankStatement } from "@/services/transactions.service";
import { mapGetters } from "vuex";
import {GetCurrentWorkspace} from "@/services/settingsbusiness.service";

export default {
  name: "ConfirmImport",
  components: {},
  data() {
    return {
      isLoading: false,
      transactionsHeader: ["date", "description", "amount","type","particulars","code","reference"],
      uploadError: {
        status: null,
        message: "",
      },
      currency:localStorage.getItem('CURRENCY')
    };
  },
  computed: {
    ...mapGetters({
      getTabState: "general/getTabState",
      getBankStatementItems: "transactions/getBankStatementItems",
      getAll: "transactions/getAll",
      transactionsItems: "transactions/confirmedColumns",
    }),
    tabState: {
      get() {
        return this.getTabState;
      },
      set(val) {
        this.$store.dispatch("general/setTabState", val);
      },
    },
    bankStatementItems: {
      get() {
        return this.getBankStatementItems;
      },
    },
  },
  methods: {
    async loadCurrentWorkspace() {
      let {data} = await GetCurrentWorkspace();
      this.currency = data.currency;
    },
    async uploadStatement() {
      let payload = {
        request_id: this.getAll.request_id,
        date_format: this.getAll.date_format,
        date_col: this.getAll.date_col,
        amount_col: this.getAll.amount_col,
        starts_from: this.getAll.starts_from,
        description_col: this.getAll.description_col,
        type_col:this.getAll.type_col,
        code_col:this.getAll.code_col,
        reference_col:this.getAll.reference_col,
        particular_col:this.getAll.particulars_col,
        account: `${this.getAll.account.type.toLowerCase()},${
          this.getAll.account.subcategory
        },${this.getAll.account.account}`,
      };
      try {
        let { data, status } = await UploadMatchBankStatement(payload);
        if (status === 200) {
          this.uploadError.status = false;
          let payloadNotify = {
            isToast: true,
            title: "Upload Bank Statement",
            content: "The bank statement has been uploaded successfully",
            variant: "success",
          };
          this.$store.dispatch("notification/setNotify", payloadNotify);
          this.$router.push("/transactions");
        } else {
          this.uploadError.status = true;
          this.uploadError.message = data.msg;
          let payloadNotify = {
            isToast: true,
            title: "Upload Bank Statement Failed",
            content:data.msg,
            variant: "danger",
          };
          this.$store.dispatch("notification/setNotify", payloadNotify);
        }
      } catch (error) {
        console.log(error);
      }
    }
  },
};
</script>

<style scoped>
.add-question-btn:hover {
  background: #0B9B7D;
  box-shadow: inset 0px 0px 10px #ffffff;
}

/* table container */
.table-container-row {
  height: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: thin;
}
/* scrollbar size fix for webkit browsers (chrome/safari) */
.table-container-row::-webkit-scrollbar {
  height: 0.5rem;
  scrollbar-width: thin;
}
.table-container-row::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f0f0f0;
}
.table-container-row::-webkit-scrollbar-thumb {
  background-color: #cdcdcd;
}
.table-container-row .table-element {
  min-width: 1000px;
}
/* table element css */
.table-element >>> .table-header {
  /* background-color: #f7f7ff; */
  background-color: transparent;
}
.table-element >>> .table-header th {
  color: var(--prime-gray);
  font-size: 0.8rem;
  font-weight: 400;
  border-color: transparent;
}
.table-element >>> .table-body td {
  vertical-align: middle;
}
.table-element >>> .table-body tr:nth-child(even) {
  vertical-align: middle;
  background-color: var(--light);
}
.table-element >>> .table-body .main-text {
  font-size: 0.9rem;
}
.table-element >>> .table-body .sub-text {
  font-size: 0.7rem;
}
/* hyperlink custom styling */
.table-element >>> .table-body td {
  vertical-align: middle;
  padding: 0;
}
.table-element >>> .table-body td > a {
  padding: 0.75rem;
}
/* Medium devices (tablets, less than 992px) */
@media (max-width: 991.98px) {
  .table-card-row .filter-dropdown,
  .table-card-row .export-dropdown {
    min-width: auto;
  }
}
/* Small devices (landscape phones, less than 768px) */
@media (max-width: 767.98px) {
  .insight-cards-row {
    height: auto;
  }
}
</style>
